import React, { useEffect, useState } from 'react'
import Photo1 from '../../assetsS/images/back1.png'
import Photo2 from '../../assetsS/images/back2.png'
import Photo3 from '../../assetsS/images/back3.png'
import Photo4 from '../../assetsS/images/back4.png'
import Box from './BoxwithIcon'
import BackgroundComponent from './BackgroundwithColorBoxes'
import Textcomponent from './Text'
import Textwithimagecomponent from './Textonimage'
import Specification from './SarasuSpecification'
import Text1Component from './Text1'
import Stage from './Stage'
import './SchoolPartnership.css'
import Biochamp from './BioChampion'
import Biochamp1 from './BioChampText'
import VideoComp from './Video'
import VideoComp1 from './Video1'
import Cardcomp from './Card'
import Faq from './Faq'
import { Link } from 'react-router-dom'

const Gallery = () => {
  useEffect(() => {})

  return (
    <div className="sp-page">

      {/* ── HERO ──────────────────────────────────────────────── */}
      <section
        className="sp-hero"
        style={{ backgroundImage: `url(${Photo2})` }}
      >
        <div className="sp-hero__overlay" />
        <div className="container position-relative sp-hero__content text-center">

          <p className="sp-hero__eyebrow">
            Online NEET Testing Practice &amp; Evaluation,
          </p>
          <h1 className="sp-hero__headline">
            Management Software
          </h1>

          <div className="sp-hero__body mt-3">
            <p className="sp-hero__sub">
              We provide customized disciplined testing practice align with
              the school time schedule for
            </p>
            <p className="sp-hero__sub sp-hero__sub--bold">
              Physics, Chemistry &amp; Biology.
            </p>
          </div>

          <div className="sp-hero__caption mt-3">
            <p>
              SARASU NEET Online Testing Practice software has a wide-range of
              test practice, evaluation and training management
            </p>
            <p>
              platform that helps students to excel the accuracy, speed and
              tackle difficult indirect question at ease
            </p>
          </div>

          {/* Buttons — preserved as commented */}
          <div className="row justify-content-center g-3 mt-2">
            <div className="col-12 col-sm-auto">
              {/* <Link to="/SchoolEnquiry">
                <button className="btn sp-btn sp-btn--primary w-100">
                  Request Free Demo
                </button>
              </Link> */}
            </div>
            <div className="col-12 col-sm-auto">
              {/* <Link to="/SchoolAdminLogin">
                <button className="btn sp-btn sp-btn--outline w-100">
                  School Admin Login
                </button>
              </Link> */}
            </div>
          </div>

        </div>
      </section>

      {/* ── BOX WITH ICON ─────────────────────────────────────── */}
      <section className="sp-section sp-section--white">
        <Box />
      </section>

      {/* ── BACKGROUND WITH COLOR BOXES ───────────────────────── */}
      <section className="sp-section sp-section--tinted pb-5">
        <BackgroundComponent />
      </section>

      {/* ── TEXT COMPONENT ────────────────────────────────────── */}
      <section className="sp-section sp-section--white pb-5">
        <Textcomponent />
      </section>

      {/* ── TEXT ON IMAGE ─────────────────────────────────────── */}
      <section className="sp-section sp-section--white pb-5">
        <Textwithimagecomponent />
      </section>

      {/* VideoComp1 — preserved as commented
      <section className="sp-section sp-section--white pb-5">
        <VideoComp1 />
      </section> */}

      {/* ── SPECIFICATION ─────────────────────────────────────── */}
      <section className="sp-section sp-section--white">
        <Specification />
      </section>

      {/* ── STAGE + TEXT1 ─────────────────────────────────────── */}
      <section className="sp-section sp-section--tinted pb-5 lightgrayback">
        <Text1Component />
        <Stage />
      </section>

      {/* ── BIO CHAMPION ──────────────────────────────────────── */}
      <section className="sp-section sp-section--white">
        <Biochamp />
      </section>

      {/* ── BIO CHAMP TEXT + VIDEO SECTION ────────────────────── */}
      <section className="sp-section sp-section--white sp-video-section">
        <div className="container-fluid px-0">
          <div className="row g-0 align-items-stretch">

            <div className="col-12 p-4 p-md-5">
              <div className="w-100">
                <Biochamp1 />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── VIDEO COMP (original standalone) ──────────────────── */}
      <section className="sp-section sp-section--tinted pt-5">
        <VideoComp />
      </section>

      {/* ── CARDS ─────────────────────────────────────────────── */}
      <section className="sp-section sp-section--white">
        <Cardcomp />
      </section>

      {/* ── FAQ ───────────────────────────────────────────────── */}
      <section className="sp-section sp-section--tinted">
        <Faq />
      </section>

    </div>
  )
}

export default Gallery